module.exports = __webpack_public_path__ + "img/1.782d2cd3.jpg";